export default __webpack_public_path__ + "static/media/facebook_icon.df74ea7b.svg";